import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;
`;

export const Image = styled.img`
	cursor: zoom-in !important;
	width: 100%;
	max-width: 200px;
	max-height: 100px;
	height: auto;
	object-fit: contain;
	border: 1px solid ${({ theme }) => theme.grayLight};
`;

export const BoxImage = styled.div`
	position: relative;
	width: 100%;
	max-width: 100px;
	overflow: hidden;
`;
